import { TLCEXT } from "../../../../js/lib/ext/Ext";
import { ApplicationData } from "../ApplicationData";
import { PrintBase } from "./PrintBase";
import { LS2PAC_Utils } from "./Utils";

export class PrintMyData extends PrintBase {
  constructor() {
    super({
      dataTitle: ApplicationData.language.myAccount,
      docName: ApplicationData.language.myAccount,
    });
	this.exportData;
  }
  print(exportData) {
    this.exportData = exportData;

    this.manipulateData();

    var html = this.buildExportData(exportData);

    this.buildHTML(html);

    this.loadData();
  }
  manipulateData() {
    if (this.exportData.loans) {
      $.each(this.exportData.loans, function (index, loan) {
        if (loan.dueDate) {
          loan.dueDateString = LS2PAC_Utils.getDateString(loan.dueDate);
        }
        if (loan.outDate) {
          loan.outDateString = LS2PAC_Utils.getDateString(loan.outDate);
        }
      });
    }
    if (this.exportData.requests) {
      $.each(this.exportData.requests, function (index, request) {
        if (request.holdRequestedDate) {
          request.holdRequestedDateString = LS2PAC_Utils.getDateString(
            request.holdRequestedDate
          );
        }
      });
    }
    if (this.exportData.loanHistory) {
      $.each(this.exportData.loanHistory, function (index, loan) {
        if (loan.outDate) {
          loan.outDateString = LS2PAC_Utils.getDateString(loan.outDate);
        }
      });
    }
  }
  buildExportData() {
    var exportData = this.exportData;

    var html = "";
    if (exportData.accountSummary) {
      const patron = exportData.accountSummary.patron;
      html += TLCEXT.Template(
        '<div><h2 align="center">{languageUtil.accountInformation}</h2>' +
          "<div>{patron.fullName}</div>" +
          "<div {resourceUtil.hideIfPersonalInformationIsHidden}>" +
          "<div>{patron.address1}</div>" +
          "<div>{patron.address2}</div>" +
          "<div>{patron.city} {patron.state}, {patron.zipcode}</div>" +
          "<div>{patron.country}</div>" +
          "<br>" +
          "<div>{languageUtil.exportData_phone}: {patron.phone} </div>" +
          "<div>{languageUtil.exportData_email}: {patron.email}</div>" +
          "<br>" +
          "</div>" +
          "<div>{languageUtil.exportData_libraryId}: {patron.patronId}</div>" +
          "<div>{languageUtil.exportData_cardExpirationDate}: {patron.cardExpirationDateString}</div>" +
          "<div>{languageUtil.exportData_status}: {patron.status}</div>" +
          "<br>" +
          "<div>{languageUtil.accountSummary}:</div>" +
          "<div>{languageUtil.exportData_loanCount}: {patron.loanCount}</div>" +
          "<div>{languageUtil.exportData_itemsOverdue}: {patron.itemsOverdue}</div>" +
          "<div>{languageUtil.exportData_itemsLost}: {patron.lostCount}</div>" +
          "<div>{languageUtil.exportData_pendingHolds}: {patron.pendingHolds}</div>" +
          "<div>{languageUtil.exportData_arrivedHolds}: {patron.arrivedHolds}</div>" +
          "<div>{languageUtil.exportData_fines}: {languageUtil.currency}{feesInCurrency}</div>" +
          "</div>" +
          '<br class="pagebreak">'
      ).populate({
        ...exportData.accountSummary, 
        feesInCurrency: LS2PAC_Utils.convertPenniesToCurrency(patron.fees),
      });
    }
    if (exportData.loans) {
      let isSerial = false;
      $.each(exportData.loans, function (index, loan) {
        loan.index = index + 1;
        if (
          (loan.enumeration && loan.enumeration.length > 0) ||
          (loan.chronology && loan.chronology.length > 0)
        ) {
          isSerial = true;
        }
      });
      html +=
        "<div>" +
        '<h2 align="center">' +
        ApplicationData.language.exportData_currentLoans +
        "</h2>" +
        '<table width="100%" cellpadding="5">' +
        "	<thead>" +
        "		<tr>" +
        '			<th wrap="nowrap"></th>' +
        '			<th wrap="nowrap">' +
        ApplicationData.language.exportData_titleAuthor +
        "</th>";

      if (isSerial) {
        html +=
          '		<th wrap="nowrap">' +
          ApplicationData.language.exportData_chronology +
          "</th>" +
          '		<th wrap="nowrap">' +
          ApplicationData.language.exportData_numbering +
          "</th>";
      }

      html +=
        '			<th wrap="nowrap">' +
        ApplicationData.language.exportData_renewedAndRemaining +
        "</th>" +
        '			<th wrap="nowrap">' +
        ApplicationData.language.exportData_dueDate +
        "</th>" +
        '			<th wrap="nowrap">' +
        ApplicationData.language.exportData_status +
        "</th>" +
        "		</tr>" +
        "	</thead>" +
        "	<tbody>";

      let template =
        "<tr>" +
        '<td align="left" valign="top">{index}.</td>' +
        '<td align="left" valign="top">{author} : {title}</td>';

      if (isSerial) {
        template +=
          '<td align="left" valign="top">{chronology}</td>' +
          '<td align="left" valign="top">{enumeration}</td>';
      }

      template +=
        '<td align="left" valign="top">{resourceUtil.getRenewalsInfoToPrint}</td>' +
        '<td align="left" valign="top">{dueDateString}</td>' +
        '<td align="left" valign="top">{resourceUtil.getDaysRemainingForLoans}</td>' +
        "</tr>";

      html += TLCEXT.Template(template).populate(exportData.loans);

      html += '	</tbody></table></div><br class="pagebreak">';
    }

    if (exportData.requests) {
      var isSerial = false;
      $.each(exportData.requests, function (index, request) {
        request.index = index + 1;
        if (
          (request.enumeration && request.enumeration.length > 0) ||
          (request.chronology && request.chronology.length > 0)
        ) {
          isSerial = true;
        }
      });
      html +=
        "<div>" +
        '<h2 align="center" style="text-transform: capitalize;">' +
        ApplicationData.language.requests +
        "</h2>" +
        '<table width="100%" cellpadding="5">' +
        "	<thead>" +
        "		<tr>" +
        '			<th wrap="nowrap"></th>' +
        '			<th wrap="nowrap">' +
        ApplicationData.language.exportData_titleAuthor +
        "</th>";

      if (isSerial) {
        html +=
          '		<th wrap="nowrap">' +
          ApplicationData.language.exportData_chronology +
          "</th>" +
          '		<th wrap="nowrap">' +
          ApplicationData.language.exportData_numbering +
          "</th>";
      }

      html +=
        '			<th wrap="nowrap">' +
        ApplicationData.language.exportData_status +
        "</th>" +
        '			<th wrap="nowrap">' +
        ApplicationData.language.exportData_pickupLocation +
        "</th>" +
        "		</tr>" +
        "	</thead>" +
        "	<tbody>";

      let template =
        "<tr>" +
        '<td align="left" valign="top">{index}.</td>' +
        '<td align="left" valign="top">{title}<br>{author}</td>';

      if (isSerial) {
        template +=
          '<td align="left" valign="top">{chronology}</td>' +
          '<td align="left" valign="top">{enumeration}</td>';
      }

      template +=
        '<td align="left" valign="top">{resourceUtil.getJustHoldStatus}</td>' +
        '<td align="left" valign="top">{holdPickupBranch}</td>' +
        "</tr>";

      html += TLCEXT.Template(template).populate(exportData.requests);

      html += '	</tbody></table></div><br class="pagebreak">';
    }

    if (exportData.bookings) {
      LS2PAC_Utils.convertBookingsData(exportData.bookings);
      $.each(exportData.bookings, function (index, booking) {
        booking.index = index + 1;
      });
      html +=
        "<div>" +
        '<h2 align="center">' +
        ApplicationData.language.exportData_bookings +
        "</h2>" +
        '<table width="100%" cellpadding="5">' +
        "	<thead>" +
        "		<tr>" +
        '			<th wrap="nowrap"></th>' +
        '			<th wrap="nowrap">' +
        ApplicationData.language.exportData_bookingDescription +
        "</th>" +
        '			<th wrap="nowrap">' +
        ApplicationData.language.exportData_bookedFrom +
        "</th>" +
        '			<th wrap="nowrap">' +
        ApplicationData.language.exportData_bookedUntil +
        "</th>" +
        "		</tr>" +
        "	</thead>" +
        "	<tbody>";

      html += TLCEXT.Template(
        "<tr>" +
          '<td align="left" valign="top">{index}.</td>' +
          '<td align="left" valign="top">{itemsString}</td>' +
          '<td align="left" valign="top">{whenBookedForString}</td>' +
          '<td align="left" valign="top">{whenDueBackString}</td>' +
          "</tr>"
      ).populate(exportData.bookings);

      html += '	</tbody></table></div><br class="pagebreak">';
    }
    //
    if (exportData.loanHistory) {
      let isSerial = false;
      $.each(exportData.loanHistory, function (index, historyItem) {
        historyItem.index = index + 1;
        if (
          (historyItem.enumeration && historyItem.enumeration.length > 0) ||
          (historyItem.chronology && historyItem.chronology.length > 0)
        ) {
          isSerial = true;
        }
      });

      html +=
        "<div>" +
        '<h2 align="center" style="text-transform: capitalize;">' +
        ApplicationData.language.exportData_loanHistory +
        ": " +
        exportData.startDate +
        " - " +
        exportData.endDate +
        "</h2>" +
        '<table width="100%" cellpadding="5">' +
        "	<thead>" +
        "		<tr>" +
        '			<th wrap="nowrap"></th>' +
        '			<th wrap="nowrap">' +
        ApplicationData.language.exportData_titleAuthor +
        "</th>";

      if (isSerial) {
        html +=
          '		<th wrap="nowrap">' +
          ApplicationData.language.exportData_chronology +
          "</th>" +
          '		<th wrap="nowrap">' +
          ApplicationData.language.exportData_numbering +
          "</th>";
      }

      html +=
        '			<th wrap="nowrap">' +
        ApplicationData.language.exportData_loanDate +
        "</th>" +
        "		</tr>" +
        "	</thead>" +
        "	<tbody>";

      if (exportData.loanHistory.length > 0) {
        let template =
          "<tr>" +
          '<td align="left" valign="top">{index}.</td>' +
          '<td align="left" valign="top">{title}<br>{author}</td>';

        if (isSerial) {
          template +=
            '<td align="left" valign="top">{chronology}</td>' +
            '<td align="left" valign="top">{enumeration}</td>';
        }

        template +=
          '<td align="left" valign="top">{outDateString}</td>' + "</tr>";

        html += TLCEXT.Template(template).populate(exportData.loanHistory);
      } else {
        html +=
          '<tr><td colspan="3">' +
          ApplicationData.language.noLoanHistoryInRange +
          "</td></tr>";
      }

      html += '	</tbody></table></div><br class="pagebreak">';
    }

    if (exportData.fines) {
      let isSerial = false;
      $.each(exportData.fines, function (index, fine) {
        fine.index = index + 1;
        if (
          (fine.enumeration && fine.enumeration.length > 0) ||
          (fine.chronology && fine.chronology.length > 0)
        ) {
          isSerial = true;
        }
      });
      html +=
        "<div>" +
        '<h2 align="center">' +
        ApplicationData.language.exportData_fines +
        "</h2>" +
        '<table width="100%" cellpadding="5">' +
        "	<thead>" +
        "		<tr>" +
        '			<th wrap="nowrap"></th>' +
        '			<th wrap="nowrap">' +
        ApplicationData.language.exportData_titleAuthor +
        "</th>";

      if (isSerial) {
        html +=
          '		<th wrap="nowrap">' +
          ApplicationData.language.exportData_chronology +
          "</th>" +
          '		<th wrap="nowrap">' +
          ApplicationData.language.exportData_numbering +
          "</th>";
      }

      html +=
        '			<th wrap="nowrap">' +
        ApplicationData.language.exportData_comments +
        "</th>" +
        '			<th wrap="nowrap">' +
        ApplicationData.language.exportData_fine +
        "</th>" +
        "		</tr>" +
        "	</thead>" +
        "	<tbody>";

      let template =
        "<tr>" +
        '<td align="left" valign="top">{index}.</td>' +
        '<td align="left" valign="top">{title}<br>{author}</td>';

      if (isSerial) {
        template +=
          '<td align="left" valign="top">{chronology}</td>' +
          '<td align="left" valign="top">{enumeration}</td>';
      }

      template +=
        '<td align="left" valign="top">{feeComment}</td>' +
        '<td align="left" valign="top">{languageUtil.currency}{resourceUtil.getFeeInCurrency}</td>' +
        "</tr>";

      html += TLCEXT.Template(template).populate(exportData.fines);

      html += '	</tbody></table></div><br class="pagebreak">';
    }

    return html;
  }
}
